/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
import { Menu } from "@headlessui/react";
import { motion } from 'framer-motion'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React from "react";
import config from "../../../../../config";

export default function LotSingle(props){

    const {lot, auctionData, setLotNumber, setLotTitle, setLotId,
        setDeleteLotModal} = props;

    const Navigate=useNavigate();
    const {id,uid}=useParams();
    const location = useLocation();

    return(
        <>
            <motion.tr className="border-b border-[#DEDEDE] table-row h-14 " 
                id= "list-items"
                initial={{ opacity: 0, y: 0 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: lot.lot_number * 0.002 }}>
                <td className=" text-[#343434]  px-4 py-3 text-[14px] leading-normal font-medium text-center">
                    {lot.lot_number}</td>
                <td><img 
                    alt="Lot image"     
                    src={lot?.images ? ((lot?.images.length===0) ? "/images/img-lotlist.png" : 
                        `${config.Storage.CDN}${lot.images.find((image) => image.featured).url}`) : "/images/img-lotlist.png"}
                    className=" px-4 py-3 w-[95px] h-[77px]" /></td>
                <td className=" text-[#343434] px-4 py-3 text-[14px] leading-normal font-medium cursor-pointer hover:underline" 
                    onClick={()=>Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/view/${lot.lot_number}`,
                        { state: { search: location.search }})}>
                    {lot.title1.length > 20 ? lot.title1.substring(0, 20) + '...' : lot.title1}</td>
                <td className=" text-[#343434] px-4 py-3 text-[14px] leading-normal font-medium truncate max-w-[170px]" 
                    title={(lot.reserve===0 || lot.reserve===undefined) ? '-' : Number(lot.reserve).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                        style: 'currency',
                        currency: auctionData.currency,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    })} >
                    {(lot.reserve===0 || lot.reserve===undefined) ? '-' : Number(lot.reserve).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                        style: 'currency',
                        currency: auctionData.currency,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    })}
                </td>
                <td className="text-[#343434] px-4 py-3 text-[14px] leading-normal font-medium">
                    {lot.number_of_telephone_bids ? lot.number_of_telephone_bids : '-'}
                </td>
                <td className="text-[#343434] px-4 py-3 text-[14px] leading-normal font-medium">
                    {lot.number_of_absentee_bids ? lot.number_of_absentee_bids : '-'}</td>
                <td className="sm:relative  sm:bg-transparent bg-[#fff]  sticky top-0 right-0">
                    <div className="sm:px-4 px-2 h-fit py-[43px] sm:shadow-none shadow-bs7 ">
                        <span className="flex justify-end ">
                            <Menu as="div" className="relative" >
                                <Menu.Button>
                                    <img src="/images/three-dots-icon-black.svg" alt="img" 
                                        className="cursor-pointer three-dots-icon" type="button"
                                        id="action-lot"
                                        data-testid={`action-${lot.lot_number}`} />
                                </Menu.Button>
                                <Menu.Items>
                                    <div className="dropdown-cont absolute overflow-hidden rounded-[10px] float-left 
                                                    m-0 w-[150px] py-2 px-2 min-w-max right-0 z-[50] 
                                                    list-none  border-none bg-white bg-clip-padding 
                                                    text-left text-base shadow-bs3 ">
                                        <Menu.Item>
                                            <button data-testid="view-lot" 
                                                onClick={()=>Navigate(`/auctions/${id}/${uid}/lots/view/${lot.lot_number}`, 
                                                    { state: { search: location.search }})}
                                                className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto text-left block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2 
                                                            text-[12px] font-medium text-[#343434] cursor-pointer hover:bg-[#E6E6E6] hover:rounded-[11px]"
                                            >View bids</button>
                                        </Menu.Item>
                                        {(auctionData.status=="Draft" || auctionData.status=="Published") && <Menu.Item>
                                            <button data-testid='update-lot'
                                                onClick={()=>Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/${lot.lot_number}`,
                                                    {state : { auction: auctionData, search: location.search } })}
                                                className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2 hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                text-[12px] font-medium text-[#343434] text-left cursor-pointer disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto"
                                            >Edit</button>
                                        </Menu.Item>}
                                        <Menu.Item>
                                            <button
                                                disabled={auctionData.status!=="Draft"}
                                                onClick={()=>{setDeleteLotModal(true), 
                                                setLotNumber(lot.lot_number),
                                                setLotId(lot._id),
                                                setLotTitle(lot.title1)}}
                                                className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                            py-2 text-[12px] font-medium text-[#343434] disabled:text-[hsl(240,4%,65%)] text-left"
                                                data-testid="delete-lot"
                                            >Delete</button>
                                        </Menu.Item>
                                    </div>
                                </Menu.Items>
                            </Menu>
                        </span>  
                    </div> 
                </td>
            </motion.tr>
        </>
    )
}